module.exports = __webpack_public_path__ + "static/media/LogoDesktop.a5fdeff4.svg";